import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { WhatsAppPage } from '../../../features/B2a/whatsapp-page';

/** D-150: ?channel=<id> picks the number (a WhatsApp channel; unknown / missing -> the main number) */
const search = z.object({ channel: z.string().optional().catch(undefined) });

/** #/whatsapp — the number, connection tab (status, live QR, pairing code, quota, events, restart). Lane B2a. */
export const Route = createFileRoute('/_app/whatsapp/')({
  validateSearch: search,
  component: Connection,
});

function Connection() {
  const { channel } = Route.useSearch();
  return <WhatsAppPage tab="connection" channelId={channel} />;
}
